/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuySingleCharterQuotaApiRequest } from '../../models/buy-single-charter-quota-api-request';
import { StatusedBasedResponseInfoIEnumerableResultApiResult } from '../../models/statused-based-response-info-i-enumerable-result-api-result';

export interface ApiHotelManageAddSingleCharterQuotaPost$Params {
      body: BuySingleCharterQuotaApiRequest
}

export function apiHotelManageAddSingleCharterQuotaPost(http: HttpClient, rootUrl: string, params: ApiHotelManageAddSingleCharterQuotaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageAddSingleCharterQuotaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatusedBasedResponseInfoIEnumerableResultApiResult>;
    })
  );
}

apiHotelManageAddSingleCharterQuotaPost.PATH = '/api/hotel/manage/add/single/charter-quota';
